<template>
    <b-container fluid>
      <b-row>
        <b-col lg="4">
          <iq-card class="profile-block">
            <template v-slot:default>
              <div class="user-details-block" v-if="patient">
                <div class="user-profile text-center">
                  <img v-if="patient.profilePic" :src="patient.profilePic" alt="profile-img" class="profile-pic">
                  <img v-else src="../../assets/images/page-img/48.png" alt="profile-img" class="avatar-130 img-fluid">
                </div>
                <div class="text-center mt-3 top-info">
                  <h4><b>{{ patient.firstName }} {{patient.lastName }}</b></h4>
                  <p>{{ patient.email }}</p>
                </div>
                <hr>
                <ul class="doctoe-sedual d-flex align-items-center justify-content-between p-0">
                  <li class="text-center">
                    <h3 v-if="patient.exerciseCount" class="counter">{{ patient.exerciseCount }}</h3>
                    <h3 v-else class="counter">0</h3>
                    <span>Workouts</span>
                  </li>
                  <li class="text-center">
                    <h3 class="counter">0</h3>
                    <span>Appointments</span>
                  </li>
                </ul>
              </div>
            </template>
          </iq-card>
        </b-col>
      </b-row>
      <PatientCalendar></PatientCalendar>
    </b-container>
  </template>
<script>
import IqCard from '../../components/xray/cards/iq-card'
import { xray } from '../../config/pluginInit'
import getDocument from '../../services/getDocument'
import firebase from '../../../firebase'
import PatientCalendar from '../PatientViews/PatientCalendar.vue'

const body = document.getElementsByTagName('body')

export default {
  name: 'PatientHome',
  components: { IqCard, PatientCalendar },
  setup () {
    const firebasePatient = firebase.firebaseAuth.currentUser
    const { document: patient } = getDocument('users', firebasePatient.uid)

    return {
      patient
    }
  },
  mounted () {
    xray.index()
    body[0].classList.add('sidebar-main-menu')
  },
  unmounted () {
    body[0].classList.remove('sidebar-main-menu')
  }
}
</script>

<style scoped>
  .profile-pic{
    height: 130px; width: 130px; line-height: 130px; font-size: 1.6rem;
    margin: auto;
  }

  .profile-block {
    margin-top: 65px;
    margin-left: auto;
  }
</style>
